
  document.addEventListener('DOMContentLoaded', function () {
   var swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      500: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 0
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 0
      },
      1500: {
        slidesPerView: 4,
        spaceBetween: 0
      },
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: false,
    centerMode: false,
  });
    });


document.addEventListener("DOMContentLoaded", function() {
  const today = new Date();
  const daysAfterToday = 0;
  const shipDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + daysAfterToday);

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const day = shipDate.getDate();
  const month = months[shipDate.getMonth()];
  const formattedDate = `${day} ${month}`;

  document.getElementById('shipping-custom').textContent = formattedDate;
});


document.addEventListener("DOMContentLoaded", () => {
    const updateCountdown = (element) => {
        const setCountdownDate = () => {
            const today = new Date();
            return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 0).getTime();
        };

        const formatTime = (time) => String(time).padStart(2, '0');

        const displayCountdown = (distance) => {
            const days = formatTime(Math.floor(distance / (1000 * 60 * 60 * 24)));
            const hours = formatTime(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            const minutes = formatTime(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
            const seconds = formatTime(Math.floor((distance % (1000 * 60)) / 1000));
            element.innerHTML = `${days}:${hours}:${minutes}:${seconds}`;
        };

        const countdownInterval = () => {
            const countDownDate = setCountdownDate();
            const x = setInterval(() => {
                const now = new Date().getTime();
                const distance = countDownDate - now;

                if (distance < 0) {
                    clearInterval(x);
                    element.innerHTML = "EXPIRED";
                    updateCountdown(element); // Reset for the next day
                } else {
                    displayCountdown(distance);
                }
            }, 1000);
        };

        countdownInterval();
    };

    const countdownElements = document.querySelectorAll(".countdown");
    countdownElements.forEach((element) => updateCountdown(element));
});

